import React from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import { Section } from '@wix/da-a11y/pkg/components/headings/tagWrappers';
import { DumboProps as Props } from '../types';
import {
  getIsShortStatus,
  getStatusBackgroundProps,
  styleFromWidthHeight,
  getTextDumboTypeBySize,
} from '../../_helpers';
import ExcerptRenderer from '../../../TextRenderer/ExcerptRenderer';
import Background from '../../../Background';

import s from './Status.scss';

export const StatusDumbView: React.FC<Props> = ({
  deviation,
  width,
  height,
  className,
  'aria-hidden': ariaHidden,
  responsive = true,
}) => {
  const { t } = useTranslation();
  const { textContent } = deviation;

  if (!textContent) {
    return null;
  }

  const type = getTextDumboTypeBySize(height || width);
  const style = styleFromWidthHeight({ width, height }, responsive);
  const backgroundProps = getStatusBackgroundProps(deviation);
  return (
    <Section style={style}>
      <Background
        className={classnames(
          s['root'],
          s[type],
          getIsShortStatus(deviation, true) ? s['short'] : s['long'],
          className
        )}
        contentClassName={s[`content-${type}`]}
        width={width}
        height={height}
        variant="status"
        {...(backgroundProps as any)}
      >
        <div className={s['body']} aria-hidden={ariaHidden}>
          <ExcerptRenderer
            className={s['body-inner']}
            textContent={textContent}
            htmlExcerptLegacy
            emptyPlaceHolder={`[${t('deviationview.unknown.nopreview')}]`}
          />
        </div>
      </Background>
    </Section>
  );
};
StatusDumbView.displayName = 'StatusDumbView';

export default StatusDumbView;
